'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './anchor.component';
import dynamic from 'next/dynamic';

const DynamicAnchorComponent: ComponentType<Props> = dynamic(() => import('./anchor.component'));

export default DynamicAnchorComponent;

export function calculateAnchorPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [{ sinceWidth: 0, height: 0 }];

  return {
    heightSinceWidth
  };
}
